import type { id } from './base';

export interface CommonMonitoringProps extends id {
  visit_type: string;
  sub_type: string;
  start_date: string;
  end_date: string;
  actual_start_date: string;
  actual_end_date: string;
}

export interface MonitoringLogEdit extends CommonMonitoringProps {
  updated_by: string;
}

export interface MonitoringVisitLogType extends id, CommonMonitoringProps {
  visit_no: number;
  visit_name: string;
  created_by: string;
  start_date: string;
  created_on: string;
  major_version: number;
  visit_type: string;
  sub_type: string;
  end_date: string;
  actual_start_date: string;
  actual_end_date: string;
  visit_purpose: string;
  site_level_signed_by: string;
  sponsor_level_signed_by: string;
}

export interface CommonVisitLogValidation {
  sub_type: boolean;
  start_date: boolean;
  end_date: boolean;
  actual_start_date: boolean;
  actual_end_date: boolean;
}

export function getLogValidationReset(): CommonVisitLogValidation {
  return {
    sub_type: false,
    start_date: false,
    end_date: false,
    actual_start_date: false,
    actual_end_date: false
  };
}
